import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as api from './api/api' // 导入api接口
import 'amfe-flexible'
import {
  Button,
  Popup,
  Form,
  Field,
  Toast,
  Icon,
  Checkbox,
  PullRefresh,
  List,
  Cell,
  CellGroup,
  Dialog,
  Overlay,
  Col,
  Row,
  Tab,
  Tabs,
  Empty,
} from 'vant'
import VConsole from 'vconsole'

Vue.use(Form)
  .use(Field)
  .use(Popup)
  .use(Button)
  .use(Toast)
  .use(Icon)
  .use(Checkbox)
  .use(PullRefresh)
  .use(List)
  .use(Cell)
  .use(CellGroup)
  .use(Dialog)
  .use(Overlay)
  .use(Col)
  .use(Row)
  .use(Tab)
  .use(Tabs)
  .use(Empty)

if (process.env.VUE_APP_Version === 'test') {
  new VConsole()
}
// new VConsole()

window.$api = api

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
